import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ClientListPanel from '../components/panels/ClientListPanel';
import connectionService from '../../services/community/connectionService';
import tagService from '../../services/community/tagService';
import useAdmins from '../../hooks/community/useAdmins';
import usePersonalConnections from '../../hooks/account/usePersonalConnections';
import userService from '../../services/userService';
import inviteService from '../../services/community/inviteService';
import useCommunityEffect from '../../hooks/effects/useCommunityEffect';
import membersService from '../../services/community/adminService';
import businessAdminService from '../../services/business/adminService';

/*
 * This page is used to display the dashboard, the main page
 */
export default function ContactsPage(): JSX.Element {
  const admins = useAdmins();
  const personalConnections = usePersonalConnections();
  const location = useLocation();
  const navigate = useNavigate();
  const isBusiness = process.env.REACT_APP_APPLICATION_VERSION === 'BUSINESS';
  const [showInviteModal, setShowInviteModal] = React.useState<boolean>(false);
  const [openInviteModal, setOpenInviteModal] = React.useState<boolean | undefined>(location.state?.openInviteModal);

  React.useEffect(() => {
    if (openInviteModal) {
      setShowInviteModal(true);
      navigate(location.pathname, { replace: true });
      setOpenInviteModal(undefined);
    }
  }, [openInviteModal, navigate, location.pathname]);

  useCommunityEffect((): void => {
    connectionService.getConnections();
    tagService.fetchTags();
    inviteService.fetchInvite().catch(
      (e) => {
        console.error('Failed to fetch invite fields:', e);
      }
    );
    if (admins.length === 0) {
      if (isBusiness) {
        businessAdminService.getAllAdmins();
      } else {
        membersService.getAllAdmins();
      }
    }
    if (personalConnections.length === 0) {
      userService.getConnections();
    }
  }, []);

  return <ClientListPanel showInviteModalInitially={showInviteModal}/>;
}
